define('destination', function(require) {
    'use strict';

    require('../modules/components/sticky-map');

});